import { FragmentDefiner } from "../../../../../GlobalHooks/useReadFragment";
import { useEffect, useState } from "react";
import { PropComponentMode } from "../../../PropertyInterfaces";
import { gql } from "@apollo/client";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ButtonsLeadsSource, ModalState } from "../../TextForm/type";
import { ButtonType } from "antd/lib/button";
import { Listing } from "shared-components";
import { REGISTER_MUTATION, USER_EXISTS_QUERY } from "shared-components/Components/User/User.querys";
import { useUser } from "shared-components/Components/User/User.hook";
import cookie from "js-cookie";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";
import { FormCallToActions } from "shared-components/Contexts/ContactModal/context";

const REQUEST_WPP_MUTATION = gql`
	mutation request_wpp_mutation(
		$property_id: Int!
		$type: PropEntityType
		$email: String
		$name: String
		$phone: String
	) {
		requestPhoneAgent(
			property_id: $property_id
			isWpp: true
			type: $type
			email: $email
			name: $name
			phone: $phone
		 ){
			name
			phone
		}
	}
`;

export interface OwnerWspInterface {
	id?: number | string;
	text?: string;
	btnType?: ButtonType;
	listing?: Listing;
	disabled?: boolean;
	queryRouter?: string;
	onWpClick?: () => void;
	forceState?: ModalState;
	owner?: any,
	isProject: boolean,
	dataModal?: any,
	setDataModal?: any,
	hasAcceptedTerms?: boolean;
	onTermsError?: (e) => void;
	onBeforeAction?: (e, cta: "whatsapp") => boolean;
	callback?: ({ ctaButtons } : { ctaButtons: FormCallToActions }) => void;
	handleCloseContactModal?: () => void;
	source?: ButtonsLeadsSource;
	propertyLink?: string;
}

export const FRAGMENT_HAS_WHATSAPP = new FragmentDefiner(
	"Property",
	`
    title
    link
    owner {
        id
        name
        has_whatsapp
    }
    operation_type {
    	id
    	name
    }
`
);

const UPDATE_USER_MUTATION = gql`
	mutation updateUser($name: String, $phone: String) {
		updateUser(name: $name, phone: $phone) {
			id
		}
	}
`;

export const useWhatsppButton = (propId: number | string, isProject, leadData) => {
	const [wppMessage, setWppMessage] = useState<string>("");
	const [mutation, { loading, data: wppMutation }] = useMutation(REQUEST_WPP_MUTATION, {
		onError: error => {
			console.error("User Unauthenticated.");
		},
	});
	const [wppNumber, setWppNumber] = useState(undefined);
	const [
		registerMutation,
		{ loading: registerLoading, data: dataRegisterMutation },
	] = useMutation(REGISTER_MUTATION);
	const [updateUserMutation, { loading: updateLoading }] = useMutation(UPDATE_USER_MUTATION);
	const updateUser = ({ name, phone }) => {
		return updateUserMutation({ variables: { name, phone } });
	};
	const { user, isLoggedIn } = useUser();
	const [
		userExistsQuery,
		{ loading: userExistsLoading, data: dataUserExist, error },
	] = useLazyQuery(USER_EXISTS_QUERY, {
		fetchPolicy: "network-only",
		onError: error => {
			if (error.message.includes("no existe")) {
				registerMutation({
					variables: {
						email: leadData?.email,
						name: leadData?.name,
					},
				})
					.then(({ data }) => {
						updateUser({ name: leadData?.name, phone: leadData?.phone }).then(() => {
							user.refetch();
						});
					})
					.catch(error => {
						console.error(error);
					});
			}
		},
	});

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (wppMutation?.requestPhone) {
			let number = wppMutation?.requestPhone;
			setWppNumber(number)
		}
	}, [wppMutation]);

	let LINK_WPP =
		wppNumber && wppMessage
			? `https://wa.me/${wppNumber}?text=${encodeURIComponent(wppMessage)}`
			: null;

	//nota: como el telefono se guarda en un state, no en cache de apolo. cada ver teléfono va a hacer la mutation por separado
	const viewWpp = (type = "PROPERTY") => {
		return mutation({
			variables: {
				property_id: propId,
				type: isProject ? "PROJECT" : "PROPERTY",
				email: leadData?.email,
				phone: leadData?.phone,
				name: leadData?.name,
			},
		});
	};

	const filteredPhones = new Set(wppMutation?.requestPhoneAgent?.map(item => item.phone).filter(phone => phone))
	const phones = Array.from(filteredPhones).join(';')

	return {
		viewWpp,
		loading,
		linkWpp: LINK_WPP,
		wppPhone: phones,
		userExistsQuery
	};
};
